export default __webpack_public_path__ + "static/media/wellnesssuite.7deb25f9.jpg";